import { render, staticRenderFns } from "./PartidaFormHeader.vue?vue&type=template&id=1b148185"
import script from "./PartidaFormHeader.vue?vue&type=script&lang=js"
export * from "./PartidaFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports